angular.module('impactx.reLoginExternal').controller('ReLoginExternalDialogController', [
    '$scope',
    'ReloginExternalService',
    '$redirect',
    '$mdDialog',
    'themeFactory',
    'AppConfiguration',
    'TranslationService',
    ReLoginExternalDialogController]);

function ReLoginExternalDialogController($scope, ReloginExternalService, $redirect, $mdDialog, themeFactory, AppConfiguration, TranslationService) {
    $scope.buttonTranslation= ReloginExternalService.getButtonTranslation();
    $scope.messageTranslation= ReloginExternalService.getMessageTranslation();
    $scope.translations = TranslationService;
    $scope.url= ReloginExternalService.getUrl();
    $scope.urlUser= ReloginExternalService.getUrlUser();
    $scope.isExternal = ReloginExternalService.isExternalUser();
    $scope.theme = themeFactory.getTheme();
    $scope.hasMultipleExternalAuthorizations = AppConfiguration.get('hasMultipleExternalAuthorizations');

    this.redirectToMultipleExternalAuthorizations = function(){
        $redirect.redirectTo(null, "/chooseexternallogin");
        $mdDialog.hide();
    };

    this.redirect = function(){
        if(!$scope.isExternal){
            $redirect.redirectTo(null, "/lobby");
            $mdDialog.hide();
        }
    };
}